import { createContext } from 'react'

type TTextContext = {
  onLinkClick?: (ev: React.MouseEvent<HTMLAnchorElement>) => void
}
export const TextContext = createContext<TTextContext>({})
